import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { TokenService } from "@auth/token.service";
import { AuthenticationService } from "@auth/authentication.service";
import { canActivateByRole, ROLES } from "@shared/common";

@Injectable({ providedIn: "root" })
export class ComprasGuard implements CanActivate {
  constructor(
    private authenticationService: AuthenticationService,
    private tokenService: TokenService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    try {
      const currentUser = this.authenticationService.currentUserValue;

      if (
        currentUser &&
        !this.tokenService.isTokenExpired(currentUser.AccessToken)
      ) {
        return canActivateByRole(
          this.tokenService.decodeToken(currentUser.AccessToken),
          ROLES.COMPRAS
        );
      }
    } catch (error) {
      return false;
    }
  }
}
